<template>
  <div class="pageDiv">
    <v-card class="no-login" v-if="!$AuthSvc.isLogin() && $AuthSvc.isFw()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Register Admin</span>
      </v-card-title>

      Must login to view data
    </v-card>

    <v-card class="no-login" v-if="$AuthSvc.isLogin() && !$AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Register Admin</span>
        <br>
        <span class="label16">TBD</span>
      </v-card-title>
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin() && $AuthSvc.isAdmin()">
      <v-card-text class="main-card" v-if="$AuthSvc.isLogin()">
        <v-card-title style="padding-bottom:0">
          <span class="page-title">Register Players Admin ({{memberPlayers.length}})</span>
        </v-card-title>

        <v-card-text class="player-card">
          <span class="label18">Tournaments:</span>
          <div class="tournamentList">
            <ul>
              <li v-for="(tn, index) in registerTournaments" :key="tn">
                <input class="checkbox" type="checkbox" v-model="tn.selected" @change="loadRegisteredPlayers(tn.tournament.tournamentId)">
                <span>
                  {{tn.course.name}}
                </span>
              </li>
            </ul>
          </div>

          <br>
          <span class="label18">Registered Players:</span>
          <div class="nameList">
            <ul>
              <li v-for="(player, index) in registerPlayers" :key="player">
                <span>
                  {{index+1}}. {{player.firstName}} {{player.middleName}} {{player.lastName}}
                </span>
              </li>
            </ul>
          </div>
        </v-card-text>

          <br>
        <v-card-text>
          <span class="label18">Select name to register:</span>
          <div class="nameList">
            <ul>
              <li v-for="(memberPlayer, index) in displayPlayers" :key="memberPlayer.playerId">
                <input class="checkbox" type="checkbox" v-model="memberPlayer.selected">
                <span>
                  {{index+1}}. {{memberPlayer.player.firstName}} {{memberPlayer.player.middleName}} {{memberPlayer.player.lastName}}
                </span>
              </li>
            </ul>
          </div>
        </v-card-text>

        <v-card-text>
          <div style="display:inline-block;width:100%;">
            <v-btn class="add-button" @click="submit()">Save</v-btn>
          </div>
        </v-card-text>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      memberPlayers: [],
      displayPlayers: [],
      registerPlayers: [],
      registerPlayerIds: [],
      registerTournaments: [],
      showFW: false
    }),
    mounted: function() {
      this.loadTournaments();
      this.loadPlayers();
    },
    methods: {
      loadTournaments() {
        var _this = this;

        _this.$CommandSvc.get(_this, '/public/tournaments/status/REGISTER', function(data) {
          _this.registerTournaments = data;
          for(var i=0; i < _this.registerTournaments.length; i++) {
            _this.registerTournaments[i].selected = false;
          }
        });
      },
      loadPlayers() {
        var _this = this;

        this.axios.get('/admin/players')
        .then(function (response) {
            _this.memberPlayers = response.data;
            for(var i=0; i < _this.memberPlayers.length; i++) {
              _this.memberPlayers[i].selected = false;
            }
            _this.displayPlayers = _this.memberPlayers;
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
      },
      loadRegisteredPlayers(tournamentId) {
        var _this = this;

        _this.$CommandSvc.get(_this, '/api/tournaments/' + tournamentId + '/registrations-admin', function(data) {
          _this.registerPlayers = data;
          _this.registerPlayerIds = new Array();
          for(var i=0; i < data.length; i++) {
            _this.registerPlayerIds.push(data[i].playerId);
          }

          _this.updateList();
        });
      },
      updateList() {
        var _this = this;

        _this.displayPlayers = new Array();
        for(var i=0; i < _this.memberPlayers.length; i++) {
          if (_this.showFW) {
            if (_this.memberPlayers[i].player.isFw === 'Y') {
              _this.memberPlayers[i].selected = false;
              if (! _this.registerPlayerIds.includes(_this.memberPlayers[i].player.playerId)) {
                _this.displayPlayers.push(_this.memberPlayers[i]);
              }
            }
          }
          else {
            _this.memberPlayers[i].selected = false;
            _this.displayPlayers.push(_this.memberPlayers[i]);
          }
        }
      },
      submit() {
        var _this = this;

        for(var i=0; i < _this.registerTournaments.length; i++) {
          console.log("SELECTED Tn: " + _this.registerTournaments[i].selected);
          if (_this.registerTournaments[i].selected) {
            for(var j=0; j < _this.displayPlayers.length; j++) {
              if (_this.displayPlayers[j].selected) {
                _this.save(_this.registerTournaments[i].tournament.tournamentId, _this.displayPlayers[j].player);
              }
            }
          }
        }

        _this.updateList();
      },
      save(tournamentId, player) {
          var _this = this;

          var scoreCard = {
            playerId: player.playerId,
            tournamentId: tournamentId,
            flight: player.defaultFlight,
            isOfficial: false,
            isRegister: true,
            fee: 0,
            lateFee: 0,
            raffle: 0,
            memberFee: 0,
            holeInOne: 0,
            birdieHunt: 0,
            owe: 0,
            paymentType: "Zelle",
            specialRequest: "N/A"
          };

          this.axios.post('/api/tournaments/registration', scoreCard)
          .then(function (response) {
              var scoreCard = response.data;
              for(var i=0; i < _this.displayPlayers.length; i++) {
                if (_this.displayPlayers[i].player.playerId === scoreCard.playerId) {
                  _this.displayPlayers[i].selected = false;
                }
              }
              window.location.reload();
          })
          .catch(function (error) {
              swal("Error", "Registration failed. " + player.nickName, "error");
              console.log('ERROR: ' + error);
          });
      }
    }
  }

</script>

<style scoped>
  .tournamentList {
    max-height: 100px;
    width: 100%;
    border: 1px solid black;
    padding: 10px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }

  .nameList {
    max-height: 400px;
    width: 100%;
    border: 1px solid black;
    padding: 10px;
    overflow-y: scroll;
  }

  select {
    margin-right: 10px;
  }

  .checkbox {
    height: 20px;
    width: 20px;
  }

  li span, li input {
    display: inline-block;
    margin-bottom: 3px;
    height: 28px;
  }

  li span {
    margin-left: 10px;
  }

  @media (min-width: 768px) {
    .tournamentList {
      width: 300px;
    }
  
    .nameList {
      width: 300px;
    }
  }

</style>